// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text, NineSlicePlane } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a0739642-ef59-498a-985f-3cf37cb63b0a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '6a00d477-3878-4d83-a964-e691be847610',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.9
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Screen_Woods',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a',
      data: {
        DEBUG: true
      }
    },
    {
      id: '53273937-c82f-4cc6-8fb5-925e5c9327ac',
      type: 'Sprite',
      name: '',
      className: '',
      x: -182,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Node',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    },
    {
      id: '993aedc7-d076-4034-bcea-93539fb03e40',
      type: 'Sprite',
      name: '',
      className: '',
      x: -108,
      y: -18,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Item_Gold_Background_Pointer',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    },
    {
      id: '543506fb-693c-4465-b60b-3a2f2a3b20f4',
      type: 'Sprite',
      name: 'nodeCrystal',
      className: '',
      x: -182,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Node_Crystal_Blue',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a',
      stateByName: {
        unlocked: {
          texture: 'Collect_Event_Node_Crystal_Green'
        }
      }
    },
    {
      id: 'c4571605-1d77-4e7c-97a9-4f30625a99d8',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -83,
      y: -76,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 301,
      height: 156,
      leftWidth: 30,
      topHeight: 34,
      rightWidth: 31,
      bottomHeight: 36,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Rewards_Background_9Slice_31x30x31x34',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    },
    {
      id: 'bf6b045a-8428-4857-b996-0bae989ac38e',
      type: 'Sprite',
      name: 'status',
      className: '',
      x: 198,
      y: 66,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gold_Lock',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a',
      stateByName: {
        unlocked: {
          texture: 'Check'
        }
      }
    },
    {
      id: 'be6f9854-c4ef-484f-8819-7e1eb2f68885',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 77,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    },
    {
      id: 'b570a53b-5286-4c8f-be34-eb6208391719',
      type: 'Container',
      name: 'rewardSlot',
      className: '',
      x: 77,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    },
    {
      id: '05f14723-318d-4ca1-b73e-6724e27485c2',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: -182,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 39,
      maxHeight: 72,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 38,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#003BE4',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a',
      stateByName: {
        unlocked: {
          style: {
            stroke: '#23601E'
          }
        }
      }
    },
    {
      id: 'a06cae71-422c-4c2c-8ccb-682886fb32ad',
      type: 'NineSlicePlane',
      name: 'nodePath',
      className: '',
      x: -201,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 40,
      height: 112,
      leftWidth: 0,
      topHeight: 20,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Node_Like_3Slice_Vertical_20x2',
      parent: 'a0739642-ef59-498a-985f-3cf37cb63b0a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'unlocked'
  ],
  handleResize: false
} as const;

export class CollectEventRewardNodeLayout {
  static raw = raw;
  root!: Container;
  nodeCrystal!: Sprite;
  status!: Sprite;
  rewardSlot!: Container;
  levelText!: Text;
  nodePath!: NineSlicePlane;
  rotate_SPL!: (Sprite)[];
  StateName!: 'unlocked';

  constructor() {
    populate(this, raw);
  }
}
